/** 质检报告 */
import { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Spin, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import activePng from "@/images/service/inspection-active.png";
import { serviceApi } from "@/apis";
import { downloadFile } from "@/utils";
import "./index.less";
import InitData from "./mock";

interface TabListItem {
  label: string;
  key: string;
}

const Inspection = ({
  previewInfo,
  isModalOpen,
  setIsModalOpen,
}: {
  previewInfo?: {
    id: string;
    matnr: string;
  };
  isModalOpen: boolean;
  setIsModalOpen: any;
}) => {
  const [loading, setLoading] = useState(false);
  const [curInfoData, setCurInfoData] = useState<InspectionInfo>();
  const [curTab, setCurTab] = useState("");
  const [tabList, setTabList] = useState<TabListItem[]>([
    // {
    //   label: "产品分析报告",
    //   key: "A",
    // },
    // {
    //   label: "产品合格证",
    //   key: "C",
    // },
    // {
    //   label: "说明书",
    //   key: "M",
    // },
  ]);
  const [fileList, setFileList] = useState<{ [key: string]: FileInfo }>();

  const allInfoDataRef = useRef<{ [key: string]: InspectionInfo }>();
  const allFilesRef = useRef<{ [key: string]: FileInfo }>();

  const getList = useCallback(async (previewId: string) => {
    try {
      const getItem = (orderno: string, ztype: string) => {
        return new Promise((resole, reject) => {
          serviceApi
            .getInspectionInfo({
              orderno,
              ztype,
              // prueflos: "890000002981", // mock
            })
            .then((res) => {
              let result = null;
              if (res && res.result && res.result.prueflos) {
                result = res.result;
              }
              resole(result);
            })
            .catch((err: any) => {
              console.log("err", err);
              resole(null);
            });
        });
      };

      Promise.all([
        // getItem("W20240522ZRNH00009", "A"),
        // getItem("W20240522ZRNH00009", "C"),
        getItem(previewId, "A"),
        getItem(previewId, "C"),
      ]).then((res: any[]) => {
        // LAR-液氩，LOX-液氧、LIN-液氮、LINF-食品氮、MOX-医用氧
        const _matnr = res[0]?.matnr || res[1]?.matnr;
        const isLar = /LAR-/.test(_matnr);
        const isLox = /LOX-/.test(_matnr);
        const isLin = /LIN-/.test(_matnr);
        const isLinf = /LINF-/.test(_matnr);
        const isMox = /MOX-/.test(_matnr);
        const allInfoData: { [key: string]: InspectionInfo } = {};
        let _tabList: any[] = [];

        // 食品氮没有合格证
        if (isLinf) {
          res.pop();
        }
        res.forEach((el, i) => {
          // i = 0， 产品分析报告 ； i = 1， 产品合格证
          if (el) {
            const tabListItem =
              i === 0
                ? {
                    label: "产品分析报告",
                    key: "A",
                  }
                : {
                    label: "产品合格证",
                    key: "C",
                  };
            _tabList.push(tabListItem);
            const _allInfoData: any = {};
            let allInfoDataKey = "";
            // 产品分析报告
            if (i === 0) {
              _allInfoData.title = "产品分析报告";
              _allInfoData.subtitle = "Certificate of Analysis";
              allInfoDataKey = "A";
              // 氧、氮，用附件2第1页模版
              // 氩，用附件2第4、5页这个模版，报告内容与1相比，多一行备注：“注：液态氩不检测水含量”
              if (isLox || isLin || isLar) {
                // 基本信息
                const _baseInfo: any = {
                  infoList: [],
                };
                const _infoListKey = [
                  [["报告编号（Report No.）：", "zqno"]],
                  [
                    ["产品名称(Product name)", "maktx"],
                    ["规格（Specification）", "maktg"],
                  ],
                  [
                    ["执行标准(Executive standard)", "plnnrAlt"],
                    ["槽车车号 （Tanker No.）", "qkurztext"],
                  ],
                  [["取样位置 （Analysis point）", "point"]],
                ];
                _infoListKey.forEach((item) => {
                  const _item: any = {
                    id: item[0][0][0],
                    itemList: [],
                  };
                  item.forEach((_el) => {
                    _item.itemList.push({
                      label: _el[0],
                      value: el[_el[1]],
                    });
                  });
                  _baseInfo.infoList.push(_item);
                });
                _allInfoData.baseInfo = _baseInfo;
                // 表格信息
                const _tableInfos: InspectionTableInfos[] = [
                  {
                    columns: [
                      {
                        title: "项目名称",
                        subtitle: "Item",
                        dataIndex: "kurztext",
                        key: "kurztext",
                      },
                      {
                        title: "单位",
                        subtitle: "Unit",
                        dataIndex: "msehl",
                        key: "msehl",
                      },
                      {
                        title: "指标",
                        subtitle: "Index",
                        dataIndex: "qtxt40",
                        key: "qtxt40",
                      },
                      {
                        title: "分析结果",
                        subtitle: "Analysis result",
                        dataIndex: "zqmjg",
                        key: "zqmjg",
                      },
                    ],
                    dataSource: [],
                  },
                ];
                el.item &&
                  el.item.forEach((_el: any, _i: number) => {
                    _tableInfos[0].dataSource.push({
                      key: `${_el.kurztext}_${_i}`,
                      kurztext: _el.kurztext,
                      msehl: _el.msehl,
                      qtxt40: _el.qtxt40,
                      zqmjg: _el.zqmjg,
                    });
                  });
                _allInfoData.tableInfos = _tableInfos;

                if (isLar) {
                  _allInfoData.remark = "液态氩不检测水含量";
                }
                // 结论信息
                const _conclusionInfo: any = {
                  topKey: ["conclusion", "other"],
                  signatureKey: ["inspector", "checker", "date"],
                  conclusion: "结论 Conclusion：" + el.kurztext,
                  other: "其他 Other：" + el.ztext1,
                  inspector: {
                    label: "检验员 Inspector：",
                    value: el.pruefer,
                  },
                  checker: {
                    label: "审核员 Reviewer：",
                    value: el.reviewer,
                  },
                  date: {
                    label: "检验日期 Date：",
                    value: el.pastrterm,
                  },
                  sealPng: el.signet,
                };

                _allInfoData.conclusionInfo = _conclusionInfo;
              }
              // 食品氮，用附件3模版
              if (isLinf) {
                // 基本信息
                const _baseInfo: any = {
                  infoList: [],
                };
                const _infoListKey = [
                  [["报告编号（Report No.）：", "zqno"]],
                  [
                    ["产品名称(Product name)", "maktx"],
                    ["执行标准(Executive standard)", "plnnrAlt"],
                  ],
                  [
                    ["充装批号 （Fill the batch No.）", "prueflos"],
                    ["槽车车号 （Tanker No.）", "qkurztext"],
                  ],
                  [["取样位置 （Analysis point）", "point"]],
                ];
                _infoListKey.forEach((item) => {
                  const _item: any = {
                    id: item[0][0][0],
                    itemList: [],
                  };
                  item.forEach((_el) => {
                    _item.itemList.push({
                      label: _el[0],
                      value: el[_el[1]],
                    });
                  });
                  _baseInfo.infoList.push(_item);
                });
                _allInfoData.baseInfo = _baseInfo;
                // 表格信息
                const _tableInfos: InspectionTableInfos[] = [
                  {
                    title: "感官要求：",
                    columns: [
                      {
                        title: "项目",
                        subtitle: "Item",
                        dataIndex: "kurztext",
                        key: "kurztext",
                      },
                      {
                        title: "指标",
                        subtitle: "Index",
                        dataIndex: "qtxt40",
                        key: "qtxt40",
                      },
                      {
                        title: "分析结果",
                        subtitle: "Analysis result",
                        dataIndex: "zqmjg",
                        key: "zqmjg",
                      },
                    ],
                    dataSource: [
                      {
                        key: "1",
                        kurztext: "色泽",
                        qtxt40: "无色",
                        zqmjg: "符合",
                      },
                      {
                        key: "2",
                        kurztext: "状态",
                        qtxt40: "气体",
                        zqmjg: "符合",
                      },
                    ],
                  },
                  {
                    title: "理化指标：",
                    columns: [
                      {
                        title: "项目名称",
                        subtitle: "Item",
                        dataIndex: "kurztext",
                        key: "kurztext",
                      },
                      {
                        title: "单位",
                        subtitle: "Unit",
                        dataIndex: "msehl",
                        key: "msehl",
                      },
                      {
                        title: "指标",
                        subtitle: "Index",
                        dataIndex: "qtxt40",
                        key: "qtxt40",
                      },
                      {
                        title: "分析结果",
                        subtitle: "Analysis result",
                        dataIndex: "zqmjg",
                        key: "zqmjg",
                      },
                    ],
                    dataSource: [],
                  },
                ];
                el.item &&
                  el.item.forEach((_el: any, _i: number) => {
                    _tableInfos[1].dataSource.push({
                      key: `${_el.kurztext}_${_i}`,
                      kurztext: _el.kurztext,
                      msehl: _el.msehl,
                      qtxt40: _el.qtxt40,
                      zqmjg: _el.zqmjg,
                    });
                  });

                _allInfoData.tableInfos = _tableInfos;
                if (isLar) {
                  _allInfoData.remark = "液态氩不检测水含量";
                }
                // 结论信息
                const _conclusionInfo: any = {
                  topKey: ["conclusion", "other"],
                  signatureKey: ["inspector", "checker", "date"],
                  conclusion: "结论 Conclusion：" + el.kurztext,
                  other: "其他 Other：" + el.ztext1,
                  inspector: {
                    label: "检验员 Inspector：",
                    value: el.pruefer,
                  },
                  checker: {
                    label: "审核员 Reviewer：",
                    value: el.reviewer,
                  },
                  date: {
                    label: "检验日期 Date：",
                    value: el.pastrterm,
                  },
                  sealPng: el.signet,
                };

                _allInfoData.conclusionInfo = _conclusionInfo;
              }
              // 医用氧，用附件4模版
              if (isMox) {
                // 基本信息
                const _baseInfo: any = {
                  infoList: [],
                };
                const _infoListKey = [
                  [["报告编号（Report No.）：", "zqno"]],
                  [["产品名称(Product name)", "maktx"]],
                  [["执行标准(Executive standard)", "plnnrAlt"]],
                  [
                    [
                      "药品生产许可证编号(Drug manufacturing license No.)",
                      "dmln",
                    ],
                    ["充装批号 （Fill the batch No.", "prueflos"],
                  ],
                  [
                    ["充装日期（Filling date）", "pastrterm"],
                    ["槽车车号 （Tanker No.）", "qkurztext"],
                  ],
                  [["取样位置 （Analysis point）", "point"]],
                ];
                _infoListKey.forEach((item) => {
                  const _item: any = {
                    id: item[0][0][0],
                    itemList: [],
                  };
                  item.forEach((_el) => {
                    _item.itemList.push({
                      label: _el[0],
                      value: el[_el[1]],
                    });
                  });
                  _baseInfo.infoList.push(_item);
                });
                _allInfoData.baseInfo = _baseInfo;
                // 表格信息
                const _tableInfos: InspectionTableInfos[] = [
                  {
                    columns: [
                      {
                        title: "项目名称",
                        subtitle: "Item",
                        dataIndex: "kurztext",
                        key: "kurztext",
                      },
                      {
                        title: "指标",
                        subtitle: "Index",
                        dataIndex: "qtxt40",
                        key: "qtxt40",
                      },
                      {
                        title: "分析结果",
                        subtitle: "Analysis result",
                        dataIndex: "zqmjg",
                        key: "zqmjg",
                      },
                    ],
                    dataSource: [],
                  },
                ];
                el.item &&
                  el.item.forEach((_el: any, _i: number) => {
                    _tableInfos[0].dataSource.push({
                      key: `${_el.kurztext}_${_i}`,
                      kurztext: _el.kurztext,
                      qtxt40: _el.qtxt40,
                      zqmjg: _el.zqmjg,
                    });
                  });
                _allInfoData.tableInfos = _tableInfos;
                // 结论信息
                const _conclusionInfo: any = {
                  topKey: ["conclusion", "other"],
                  signatureKey: ["inspector", "checker", "reviewer", "date"],
                  conclusion: "结论 Conclusion：" + el.kurztext,
                  other: "其他 Other：" + el.ztext1,
                  inspector: {
                    label: "检验员 Inspector：",
                    value: el.pruefer,
                  },
                  checker: {
                    label: "复核员 Checker",
                    value: el.pruefer,
                  },
                  date: {
                    label: "检验日期 Date：",
                    value: el.pastrterm,
                  },
                  reviewer: {
                    label: "负责人 Reviewer：",
                    value: el.reviewer,
                  },
                  sealPng: el.signet,
                };

                _allInfoData.conclusionInfo = _conclusionInfo;
              }
            }
            // 产品合格证
            if (i === 1) {
              _allInfoData.title = "产品合格证";
              _allInfoData.subtitle = "Certificate of Conformity";
              allInfoDataKey = "C";
              // 氧、氮 ，用附件1第1页模版
              // 氩，用附件1第4、5页这个模版，报告内容与1相比，多一行备注：“注：液态氩不检测水含量”
              if (isLox || isLin || isLar) {
                // 基本信息
                const _baseInfo: any = {
                  infoList: [],
                };
                const _infoListKey = [
                  [["报告编号（Report No.）：", "zqno"]],
                  [
                    ["产品名称(Product name)", "maktx"],
                    ["规格（Specification）", "maktg"],
                  ],
                  [
                    ["执行标准(Executive standard)", "plnnrAlt"],
                    ["取样位置 （Analysis point）", "point"],
                  ],
                ];
                _infoListKey.forEach((item) => {
                  const _item: any = {
                    id: item[0][0][0],
                    itemList: [],
                  };
                  item.forEach((_el) => {
                    _item.itemList.push({
                      label: _el[0],
                      value: el[_el[1]],
                    });
                  });
                  _baseInfo.infoList.push(_item);
                });
                _allInfoData.baseInfo = _baseInfo;
                // 表格信息
                const _tableInfos: InspectionTableInfos[] = [
                  {
                    columns: [
                      {
                        title: "项目名称",
                        subtitle: "Item",
                        dataIndex: "kurztext",
                        key: "kurztext",
                      },
                      {
                        title: "单位",
                        subtitle: "Unit",
                        dataIndex: "msehl",
                        key: "msehl",
                      },
                      {
                        title: "指标",
                        subtitle: "Index",
                        dataIndex: "qtxt40",
                        key: "qtxt40",
                      },
                      {
                        title: "结论",
                        subtitle: "Conclusion",
                        dataIndex: "zqmjg",
                        key: "zqmjg",
                      },
                    ],
                    dataSource: [],
                  },
                ];
                el.item &&
                  el.item.forEach((_el: any, _i: number) => {
                    _tableInfos[0].dataSource.push({
                      key: `${_el.kurztext}_${_i}`,
                      kurztext: _el.kurztext,
                      msehl: _el.msehl,
                      qtxt40: _el.qtxt40,
                      zqmjg: _el.zqmjg,
                    });
                  });
                _allInfoData.tableInfos = _tableInfos;
                if (isLar) {
                  _allInfoData.remark = "液态氩不检测水含量";
                }
                // 结论信息
                const _conclusionInfo: any = {
                  topKey: ["other"],
                  signatureKey: ["date"],
                  other: "其他 Other：" + el.ztext1,
                  date: {
                    label: "检验日期 Date：",
                    value: el.pastrterm,
                  },
                  sealPng: el.signet,
                };

                _allInfoData.conclusionInfo = _conclusionInfo;
              }
              // 医用氧，用附件1中最后一页模版
              if (isMox) {
                // 基本信息
                const _baseInfo: any = {
                  title: "医用氧（液态）Medical oxygen (liquid)",
                };
                _allInfoData.baseInfo = _baseInfo;
                // 医用氧合格证信息
                const _medicalOXInfo = {
                  productionDate: el.pastrterm,
                  prueflos: el.prueflos,
                  validity: el.validity,
                  altZ: el.altZ,
                  altE: el.altE,
                  butxt: el.butxt,
                  butxten: el.butxten,
                };
                _allInfoData.medicalOXInfo = _medicalOXInfo;
              }
            }
            allInfoData[allInfoDataKey] = _allInfoData;
          }
        });
        allInfoDataRef.current = allInfoData;

        if (_tabList.length) {
          const _key = _tabList[0].key;
          setCurTab(_key);
          setCurInfoData(allInfoData[_key]);
        }
        setTabList(_tabList);
      });

      const getFileId = (vbelnVl: string, zType: string) => {
        serviceApi
          .getFileByConditions({
            vbelnVl,
            zType,
          })
          .then((res) => {
            if (res && res.records && res.records.length === 1) {
              const { id, relativeLocal, fileName } = res.records[0];
              allFilesRef.current = {
                ...(allFilesRef.current || {}),
                [zType]: {
                  id,
                  relativeLocal,
                  fileName,
                },
              };
              setFileList(allFilesRef.current);
            }
          })
          .catch((err: any) => {
            console.log("err", err);
          });
      };

      // getFileId("W20240508ZRNH00002", "A");
      getFileId(previewId, "A");
      getFileId(previewId, "C");
    } catch (error: any) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (previewInfo && isModalOpen) {
      // getList(previewInfo.id, previewInfo.matnr);
      getList(previewInfo.id);
    }
  }, [previewInfo, isModalOpen, getList]);

  const changeTab = (_curtab: string) => {
    if (_curtab !== curTab) {
      setCurTab(_curtab);
      setCurInfoData(allInfoDataRef.current?.[_curtab]);
    }
  };

  const handleDownload = () => {
    const pdfInfo = fileList?.[curTab];
    if (!pdfInfo) return;
    downloadFile(
      `/crm-venus/v1/venus/files/download/${pdfInfo.relativeLocal}.id`,
      `${pdfInfo.fileName}`
    );
  };

  return (
    <Modal
      style={{ top: 50 }}
      width={1000}
      title={null}
      open={isModalOpen}
      onCancel={() => setIsModalOpen(false)}
      footer={null}
      maskClosable={false}
    >
      <Spin spinning={loading}>
        {curInfoData ? (
          <>
            <div className="inspection-title">
              <div className="inspection-title-tab">
                {tabList.map((item) => (
                  <div
                    key={item.key}
                    className={`tab-item ${
                      item.key === curTab ? "active" : ""
                    }`}
                    onClick={() => changeTab(item.key)}
                  >
                    {item.label}
                    {item.key === curTab ? (
                      <img src={activePng} alt="" />
                    ) : (
                      <></>
                    )}
                  </div>
                ))}
              </div>
              <p className="dividing-line"></p>
            </div>
            <div className="inspection-content">
              <h3 className="title">{curInfoData?.title}</h3>
              <h4 className="subtitle">{curInfoData?.subtitle}</h4>
              {/* 头部基础信息 */}
              {curInfoData?.baseInfo ? (
                <div className="base-info">
                  {curInfoData?.baseInfo.title ? (
                    <h4 className="base-info-title">
                      {curInfoData?.baseInfo.title}
                    </h4>
                  ) : (
                    <></>
                  )}
                  {curInfoData?.baseInfo.infoList &&
                    curInfoData?.baseInfo.infoList.map((item) => (
                      <div key={item.id} className="base-info-row">
                        {item.itemList.map((_item) => (
                          <div key={_item.label} className="base-info-item">
                            <span className="item-title">{_item.label}</span>
                            <span>{_item.value}</span>
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
              ) : (
                <></>
              )}
              {/* 表格信息 */}
              {curInfoData?.tableInfos ? (
                curInfoData?.tableInfos.map((item, i) => (
                  <div key={i} className="table-info">
                    {item.title ? (
                      <h4 className="table-info-title">{item.title}</h4>
                    ) : (
                      <></>
                    )}
                    {/* 表格头部 */}
                    <div className="table-content">
                      {item.columns.map((_item) => (
                        <div key={_item.key} className="table-columns">
                          <div className="table-columns-title">
                            <h5>{_item.title}</h5>
                            <h5>{_item.subtitle}</h5>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* 表格内容 */}
                    {item.dataSource.map((_item) => (
                      <div key={_item.key} className="table-content-body">
                        {item.columns.map((_keyItem) => (
                          <div className="table-columns">
                            <p
                              key={`${_item.key}_${_keyItem.key}`}
                              className="table-columns-item"
                            >
                              {_item[_keyItem.dataIndex]}
                            </p>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))
              ) : (
                <></>
              )}
              {/* 备注信息 */}
              {curInfoData?.remark ? (
                <p className="remark-info">*注：{curInfoData?.remark}</p>
              ) : (
                <></>
              )}
              {/* 其他信息 */}
              {curInfoData?.otherInfo ? (
                <p className="other-info">
                  其它 Other：{curInfoData?.otherInfo}
                </p>
              ) : (
                <></>
              )}
              {/* 结论信息 */}
              {curInfoData?.conclusionInfo ? (
                <div className="conclusion-info">
                  <div className="conclusion-info-top">
                    {curInfoData?.conclusionInfo.topKey.map((item) => (
                      <p key={item}>{curInfoData?.conclusionInfo[item]}</p>
                    ))}
                  </div>
                  <div className="conclusion-info-signature">
                    <div>
                      {curInfoData?.conclusionInfo.signatureKey.map((item) => (
                        <p key={item}>
                          {curInfoData?.conclusionInfo[item].label}
                          <span>{curInfoData?.conclusionInfo[item].value}</span>
                        </p>
                      ))}
                    </div>
                    <img src={curInfoData?.conclusionInfo.sealPng} alt="" />
                  </div>
                </div>
              ) : (
                <></>
              )}
              {/* 医用氧合格证信息 */}
              {curInfoData?.medicalOXInfo ? (
                <div className="medicalOX-Info">
                  <p>
                    【性状】
                    本品为淡蓝色液体，气化后为无色气体；无臭，无味；有强助燃力。
                  </p>
                  <p>【适应症】用于缺氧的预防和治疗</p>
                  <p>
                    【贮藏】 置耐压容器内，在-183℃
                    以下保存。本品气化后应置耐压钢瓶内，在36℃ 以下保存。
                  </p>
                  <p>【注意事项】详见说明书。</p>
                  <p>
                    Properties: This product is light blue liquid, colorless gas
                    after gasification; Odorless, tasteless; It has strong
                    combustive power.
                  </p>
                  <p>Indication: For the prevention and treatment of hypoxia</p>
                  <p>
                    Storage: Store in a pressure-resistant container below
                    -183℃. After gasification, the product should be placed in a
                    pressure cylinder and stored below 36℃.
                  </p>
                  <p>Precautions: Please refer to the instructions.</p>
                  <div className="segmentation"></div>
                  <div className="mid-info">
                    <div className="mid-info-item">
                      <span>生产日期 Production Date:</span>
                      {curInfoData.medicalOXInfo.productionDate}
                    </div>
                    <div className="mid-info-item">
                      <span>充装批号 Filling lot number:</span>
                      {curInfoData.medicalOXInfo.prueflos}
                    </div>
                    <div className="mid-info-item">
                      <span>有效期:</span>
                      {curInfoData.medicalOXInfo.validity}
                    </div>
                  </div>
                  <div className="segmentation"></div>
                  <p>执行标准：{curInfoData.medicalOXInfo.altZ}</p>
                  <p>生产企业：{curInfoData.medicalOXInfo.butxt}</p>
                  <p>
                    Implementation standard：{curInfoData.medicalOXInfo.altE}
                  </p>
                  <p>
                    Production enterprise：{curInfoData.medicalOXInfo.butxten}
                  </p>
                </div>
              ) : (
                <></>
              )}
            </div>
            <div className="inspection-bottom">
              <div className="inspection-download">
                <h4>质检单下载</h4>
                <span>
                  {fileList && fileList[curTab] ? (
                    <>
                      {fileList[curTab].fileName}
                      <DownloadOutlined onClick={handleDownload} />
                    </>
                  ) : (
                    <span className="grey">质检单生成中…请于次日下载</span>
                  )}
                </span>
              </div>
              <button
                className="close-btn pointer"
                onClick={() => setIsModalOpen(false)}
              >
                关闭
              </button>
            </div>
          </>
        ) : (
          <div className="empty">暂无数据</div>
        )}
      </Spin>
    </Modal>
  );
};

export default Inspection;
